import React from 'react';
import { Box, Typography } from '@mui/material';

export default function Serviceability() {
  return <Box><Typography variant="h4">Serviceability</Typography></Box>;
}
